import { eventMessages } from 'src/features/eventLog/utils/messages';
import { EVENT_TYPE, GATEWAY_PASS_NOT_ALLOWED_REASON, MAIN_IDENTIFIER_TYPE } from 'src/features/eventLog/types';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const identifierTypeTranslationMap: Record<MAIN_IDENTIFIER_TYPE, { id: string; defaultMessage: string }> = {
    [MAIN_IDENTIFIER_TYPE.LICENSE_PLATE]: eventMessages.licensePlate,
    [MAIN_IDENTIFIER_TYPE.TICKET]: eventMessages.ticket,
    [MAIN_IDENTIFIER_TYPE.ACCESS_KEY]: eventMessages.accessKey,
};

export const eventTypeBadgeOptions: Record<EVENT_TYPE, BadgeOption> = {
    [EVENT_TYPE.LPR_CAMERA_DETECTION]: {
        label: eventMessages.lprCameraDetection,
        icon: ICON_MAP.CAMERA,
        theme: 'yellow',
    },
    [EVENT_TYPE.ACCESS_KEY_READER_DETECTION]: {
        label: eventMessages.accessKeyReaderDetection,
        icon: ICON_MAP.KEY,
        theme: 'orange',
    },
    [EVENT_TYPE.IDENTIFIER_CREATED]: {
        label: eventMessages.identifierCreated,
        icon: ICON_MAP.CLIENT,
        theme: 'blue',
    },
    [EVENT_TYPE.VISITOR_IDENTIFIED]: {
        label: eventMessages.visitorIdentifier,
        icon: ICON_MAP.MEMBER,
        theme: 'teal',
    },
    [EVENT_TYPE.GATEWAY_PASS_ALLOWED]: {
        label: eventMessages.gatewayPassAllowed,
        icon: ICON_MAP.CHECK,
        theme: 'cyan',
    },
    [EVENT_TYPE.GATEWAY_PASS_NOT_ALLOWED]: {
        label: eventMessages.gatewayPassNotAllowed,
        icon: ICON_MAP.X_MARK,
        theme: 'amber',
    },
    [EVENT_TYPE.ACTIVE_STAY_CREATED]: {
        label: eventMessages.activeStayCreated,
        icon: ICON_MAP.CHECK,
        theme: 'lime',
    },
    [EVENT_TYPE.ACTIVE_STAY_PERIOD_CREATED]: {
        label: eventMessages.activeStayPeriodCreated,
        icon: ICON_MAP.CHECK,
        theme: 'emerald',
    },
    [EVENT_TYPE.ACTIVE_STAY_PERIOD_COMPLETED]: {
        label: eventMessages.activeStayPeriodCompleted,
        icon: ICON_MAP.CHECK,
        theme: 'purple',
    },
    [EVENT_TYPE.ACTIVE_STAY_COMPLETED]: {
        label: eventMessages.activeStayCompleted,
        icon: ICON_MAP.CHECK,
        theme: 'pink',
    },
    [EVENT_TYPE.ACTIVE_STAY_PAID]: {
        label: eventMessages.activeStayPaid,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [EVENT_TYPE.GATEWAY_OPENED]: {
        label: eventMessages.gatewayOpened,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [EVENT_TYPE.GATEWAY_CLOSED]: {
        label: eventMessages.gatewayClosed,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [EVENT_TYPE.SEND_GATEWAY_OPEN_COMMAND]: {
        label: eventMessages.sendGatewayOpenCommand,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [EVENT_TYPE.SEND_GATEWAY_CLOSE_COMMAND]: {
        label: eventMessages.sendGatewayCloseCommand,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
};

export const gatewayPassNotAllowedReasonTranslationMap: Record<
    GATEWAY_PASS_NOT_ALLOWED_REASON,
    { id: string; defaultMessage: string }
> = {
    [GATEWAY_PASS_NOT_ALLOWED_REASON.IDENTIFIER_NOT_WHITELISTED]: eventMessages.identifierNotWhitelisted,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.REQUIRED_IDENTIFIERS_NOT_COLLECTED]: eventMessages.requiredIdentifiersNotCollected,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.REQUIRED_IDENTIFIERS_NOT_VALID]: eventMessages.requiredIdentifiersNotValid,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ACTIVE_PERIOD_WITH_ACCESS_KEY]: eventMessages.activePeriodWithAccessKey,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.MEMBERSHIP_NOT_FOUND]: eventMessages.membershipNotFound,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.MEMBERSHIP_STARTING_IN_FUTURE]: eventMessages.membershipStartingInFuture,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.MEMBERSHIP_EXPIRED]: eventMessages.membershipExpired,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.RESTRICTED_GATEWAY_BY_MEMBERSHIP_TYPE]:
        eventMessages.restrictedGatewayByMembershipType,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.MISSING_MEMBERSHIP_ZONE_RULE]: eventMessages.missingMembershipZoneRule,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.OUTSIDE_ALLOWED_TIME_FRAME]: eventMessages.outsideAllowedTimeFrame,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.NO_FREE_SPACES]: eventMessages.noFreeSpaces,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.RESERVED_SPACE]: eventMessages.reservedSpace,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ALLOWED_SPACE]: eventMessages.allowedSpace,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.EXTRA_VISITOR_ALLOWED]: eventMessages.extraVisitorAllowed,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ALL_MEMBERSHIP_SPACES_USED]: eventMessages.allMembershipSpacesUsed,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ACCESS_KEY_NOT_EXISTS]: eventMessages.accessKeyNotExists,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.UNUSED_TICKET_NOT_EXISTS]: eventMessages.unusedTicketNotExists,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.VALID_IDENTIFIER_NOT_EXISTS]: eventMessages.validIdentifierNotExists,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.CLIENT_NOT_ALLOWED_IN_ENTRY_ZONE]: eventMessages.clientNotAllowedInEntryZone,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ZONE_NOT_WORKING]: eventMessages.zoneNotWorking,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ZONE_CLIENT_CAPACITY_REACHED]: eventMessages.zoneClientCapacityReached,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.ZONE_NO_FREE_SPACES]: eventMessages.zoneNoFreeSpaces,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.GATEWAY_DOES_NOT_ALLOW_UNKNOWN_MAIN_IDENTIFIER]:
        eventMessages.gatewayDoesNotAllowUnknownMainIdentifier,
    [GATEWAY_PASS_NOT_ALLOWED_REASON.UNKNOWN]: eventMessages.unknown,
};
